import { cache, initialVaultCache, } from "./cache";
import { totalActiveShares, } from ".";
import { deepAssign, } from "@utils";
import type { LoadedVault, } from "@types";
import { getAggregateError, } from "@bracket/catch";


/**
 * Retrieves the total number of outstanding shares for a vault with caching support.
 * The function uses the totalActiveShares function to get the current value and caches it for future use.
 * 
 * @param {Object} params - The parameters object
 * @param {LoadedVault} params.vault - The vault to get outstanding shares for
 * @returns {Promise<bigint>} The total number of outstanding shares
 */
export const sharesOutstanding = async ({
	vault,
  vault: {
		symbol,
		address,
	},
}: {
	vault: LoadedVault;
}): Promise<bigint> => {
	try {
		const now = Date.now();
		cache.vaults[address] = cache.vaults[address] || deepAssign({}, initialVaultCache);
		const { time, value, since, } = cache.vaults[address].shares_outstanding;
		if(since > now - time) {
			return value;
		}
		const next = await totalActiveShares({ vault, });
		cache.vaults[address].shares_outstanding.since = Date.now();
		cache.vaults[address].shares_outstanding.value = next;
		return next;
	}
	catch(error) {
		throw getAggregateError(error, `failed getting shares outstanding for vault ${symbol} ${address}`);
	}
}
